import styled from "styled-components";
import {
  BottomNavigation,
  BottomNavigationAction,
  CSSObject,
  ListItemButton,
  ListItemIcon,
  Table,
  TableBody,
  TableCell,
  Theme,
  styled as muiStyled,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { Link, NavLink } from "react-router-dom";

const drawerWidth = 240;

export const Navigation = styled.nav<{ mobileOpen: boolean }>`
  position: sticky;
  top: 0;
  ${(props) => (props.mobileOpen ? "z-index: 10000;" : "z-index: 1000;")}
  width: 100%;
  height: 60px;
  background-color: red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px;
  background-color:rgba(20, 20, 25, 0.7);
  backdrop-filter: blur(5px);
  img {
    max-width: 100%;
    width: 150px;
  }

  @media only screen and (max-width: 1200px) {
    padding: 0 10px;
  }
`;

export const LogoContainer = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;

  h2 {
    background: ${(props) =>
    props.isActive
      ? `
    linear-gradient(
    310deg,
    rgb(15 91 184 / 65%),
    rgb(27 115 218 / 65%),
    rgb(96 165 255 / 80%),
    rgb(58 138 242 / 65%)
  )`
      : "linear-gradient(135deg, #38424d 0%, #303a45 100%)"};
    padding: 3px;
    border-radius: 6px;
    font-size: 1.2rem;
  }
`;

export const NavItens = styled.ul`
  list-style: none;
  display: flex;
`;

export const ButtonGroup = styled.div`
  background-color: #1a1d23;
  padding: 15px 10px;
  border-radius: 10px;
  &:last-child {
  }
`;

export const NavButton = styled(NavLink)<{ removeActive?: boolean }>`
  text-decoration: none;
  padding: 10px;
  color: #8e8e8e;
  border-radius: 5px;
  ${(props) =>
    props.removeActive
      ? ""
      : `
  &.active {
    color: ${props.theme.primaryFont};
    background-image: linear-gradient(45deg, rgb(46, 46, 46), rgb(46, 46, 46));
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    animation: increase 300ms linear;
  }
  `}

  @keyframes increase {
    0% {
      background-size: 0% 0%;
    }

    100% {
      background-size: 100% 100%;
    }
  }
`;

export const ProfileStats = styled.div`
  display: flex;
  align-items: center;
  background-color: red;
  background-color: #1a1d23;
  padding: 4px;
  border-radius: 10px;
  margin-left: 10px;
  cursor: pointer;
  svg {
    color: ${(props) => props.theme.primaryFont};
  }
`;

export const ProfileImg = styled.div`
  filter: url(#roundHex);
  width: 35px;
  &::before {
    content: "";
    display: block;
    background-image: url("https://picsum.photos/350");
    background-position: center center;
    background-size: cover;
    padding-top: 86.6%; /* 100%*cos(30) */
    clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  }
`;

export const WalletAmount = styled.div`
  color: ${(props) => props.theme.primaryFont};
  padding: 0 10px;
`;

export const ListIcon = styled(ListItemIcon)``;
export const ListButton = muiStyled(ListItemButton)`
margin-bottom: 15px;

`;

export const Drawer = styled(MuiDrawer)`
  width: ${drawerWidth};
  flex-shrink: 0;
  white-space: nowrap;
  box-sizing: border-box;
  width: 57px;
  & .MuiDrawer-paper {
    border-radius: 50px;
    position: fixed;
    top: 40px;
    left: 10px;
    height: unset;
    width: 57px;
    overflow-x: hidden;
  }
`;

export const ListUl = styled.ul<{ themeSchema: string }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  background: ${(props) =>
    props.themeSchema === "light"
      ? "#fff"
      : `linear-gradient(
    180deg,
    #61616185 1%,
    #313131bb 60%
  )`};
  border-radius: 50px;
  width: 57px;
  position: fixed;
  top: 20px;
  box-shadow: rgba(0, 0, 0, 0.3) 2px 2px 10px 1px;
`;

export const ListWrapper = styled(NavLink) <{ svgSize: string }>`
  list-style-type: none;
  padding: 20px;
  margin: 10px 0;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  border-radius: 50px;
  cursor: pointer;
  transition: all 300ms;
  &:hover:after,
  &.active::after {
    content: "";
    position: absolute;
    top: 10px;
    left: 7px;
    width: 7px;
    height: 40px;
    border-radius: 50px;
    animation: increaseSize 200ms ease-in-out;
  }

  &:first-child:after {
    top: 14px;
  }

  &:last-child:after {
    top: 11px;
  }

  &:last-child {
    margin-top: 70px;
  }

  svg {
    font-size: ${(props) => props.svgSize};
    fill: ${(props) => props.theme.fontColor};
  }

  &:hover svg,
  &.active svg {
    fill: url(#icon-gradient) #1fa214 !important;
  }

  svg:hover {
  }

  @keyframes increaseSize {
    0% {
      height: 0px;
    }

    100% {
      height: 40px;
    }
  }
`;

export const MobileNavigation = muiStyled(BottomNavigation)`
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  border-radius: 50px;
  width: 95%;
  padding: 0px;
  min-width: 60px;
  margin: 0 auto;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 8px -1px;
  .Mui-selected svg {
    fill: url(#icon-gradient) #1FA214;
  };
`;

export const MobileNavButton = muiStyled(BottomNavigationAction)`
  padding: 0px;
  min-width: 60px;
  border-radius: 50px;
  color: ${(props) => props.theme.palette.fontColor.main};
  svg{
    fill: ${(props) => props.theme.palette.fontColor.main};
  };

`;

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 10px;
`;

export const MobileHamburgerButton = styled.button`
  display: flex;
  background-color: ${(props) => props.theme.inputColor};
  border: unset;
  border-radius: 5px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  svg {
    font-size: 1.2rem;
    color: ${(props) => props.theme.fontColor};
  }
`;

export const MobileMenu = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  height: 100dvh; /* Dynamic viewport height for mobile browsers */
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.8); /* Semi-transparent overlay */
  backdrop-filter: blur(5px);
  z-index: 9999; /* Increased z-index to ensure it's on top */
  
  /* Use transform for better performance and reliability */
  transform: ${(props) => (props.isOpen ? "translateY(0)" : "translateY(100%)")};
  opacity: ${(props) => (props.isOpen ? "1" : "0")};
  visibility: ${(props) => (props.isOpen ? "visible" : "hidden")};
  
  transition: all 400ms ease-in-out;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */

  h2 {
    color: ${(props) => props.theme.primary};
    text-align: center;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  /* Close button */
  > button {
    background-color: transparent;
    border: unset;
    display: flex;
    margin: 0 auto;
    margin-top: 15px;
    padding: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 50%;
    
    &:hover {
      background-color: ${(props) => props.theme.inputColor};
    }
    
    &:active {
      transform: scale(0.95);
    }

    h3 {
      font-size: 1.7rem;
      color: ${(props) => props.theme.fontColor};
      margin: 0;
    }
  }
`;

export const MobileMenuContent = styled.div`
  background-color: ${(props) => props.theme.bottomColor};
  height: 100%;
  width: 100%;
  padding: 0;
  position: relative;
`;

export const MobileCard = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 25px;
  height: 85%;
  overflow: auto;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  
  p {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
  }
  
  svg {
    font-size: 1.3rem;
  }
`;

export const LinkCard = styled(Link)`
  text-decoration: none;
  color: ${(props) => props.theme.fontColor};
  width: 100%;
  margin-top: 20px;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 10px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  li {
    list-style: none;
    padding: 25px 15px;
    text-align: center;
    border-radius: 10px;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: ${(props) => props.theme.inputColor};
    }
  }
`;

export const ModalWrapper = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalContainer = styled.div`
  position: relative;
  max-width: 430px;
  overflow: auto;
  padding: 20px 15px;
  padding-top: 25px;
  transition: all 400ms ease-in-out;
  
  background: rgba(18, 21, 24, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  margin: 0 10px;
  border: 1px solid rgba(42, 244, 151, 0.15);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  position: relative;
  
  h2 {
    color: #2af497;
    margin-bottom: 8px;
    font-size: 1.8rem;
  }
  
  p {
    color: ${props => props.theme.fontColor};
    opacity: 0.8;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalButton = styled.div`
 position: absolute;
  top: 7px;
  left: 10px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(30, 30, 40, 0.6);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(42, 244, 151, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 10;
  font-size: 1.1em;
  &:hover {
    background: rgba(42, 244, 151, 0.2);
    transform: scale(1.05);
  }
  
`;

export const ValidSignature = styled.div`
  p {
    margin: 20px 0;
  }
`;

export const PaymentContainer = styled.form`
  margin: 15px 0px 5px;
`;

export const RadioContainer = styled.label`
  display: flex;
`;

export const RadioNameContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  p {
    margin-top: 10px;
    font-weight: bold;
  }
`;

export const CreditCardContainer = styled.div``;

export const ChangePlanContainer = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.selectColor};
  padding: 10px;
  border-radius: 6px;
  div {
    flex-basis: 50%;
  }
  div:first-child {
    display: flex;
    flex-direction: column;

    div {
      display: flex;
      align-items: center;
      small {
        color: #969696;
      }
    }
  }
  div:last-child {
    display: flex;
    align-items: center;
    button {
      margin: 0;
    }
  }
`;
